import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OperationObserverService } from '@x/common/operation';
import {
  IShopExportOrderInvoice,
  IShopUserOrder,
  ShopOrderService,
} from '@x/ecommerce/shop-client';

interface OrderInvoiceDownloadDialogData {
  order: IShopUserOrder;
}

@Component({
  selector: 'x-order-invoice-download-dialog',
  templateUrl: './order-invoice-download-dialog.component.html',
  styleUrls: ['./order-invoice-download-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderInvoiceDownloadDialogComponent {
  operation$ = this.operation.observe<IShopExportOrderInvoice>(
    this.shopOrderService.exportOrderInvoice({ orderId: this.data.order.id }),
  );

  subheadingTranslations = {
    loading: $localize`:@@OrderInvoiceDownload.Subtitle.Loading:Generating your invoice`,
    download: $localize`:@@OrderInvoiceDownload.Subtitle.Download:Your invoice is ready to download`,
  };

  constructor(
    private operation: OperationObserverService,
    private shopOrderService: ShopOrderService,
    public dialogRef: MatDialogRef<OrderInvoiceDownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderInvoiceDownloadDialogData,
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
